import gsap from "gsap"
import MorphSVGPlugin from "gsap/MorphSVGPlugin"
import SVGPathValue = gsap.SVGPathValue
import MorphSVGVars = gsap.plugins.MorphSVGVars

export default () => {
    gsap.registerPlugin(MorphSVGPlugin)

    document.querySelectorAll('.logo-animated')?.forEach(logo => {
        let tl: gsap.core.Timeline | null = null;
        let isHovered = false;

        const createTimeline = () => {
            if (tl) return;

            tl = gsap.timeline({repeat: -1, repeatDelay: 1})

            tl.to(logo.querySelector('.letter-m'), {
                duration: .3,
                morphSVG: "M351.61 480.56L235.92 275.88H160.26V697.21H214.7V392.37H215.78L330.82 602.49H365.11L484.17 392.37H485.26V697.21H542.96V275.88H465.12L351.61 480.56Z",
                ease: "power1.inOut"
            }, 0)
                .to(logo.querySelector('.letter-o'), {
                    duration: .3,
                    morphSVG: "M700.3 262.75C642.6 262.75 607.21 299.22 607.21 359.1V605.08C607.21 664.95 642.59 701.43 700.3 701.43C758.01 701.43 793.38 664.96 793.38 605.08V359.1C793.38 299.23 757.99 262.75 700.3 262.75ZM735.68 604.53C735.68 632.84 723.16 648.08 700.3 648.08C677.44 648.08 664.92 632.84 664.92 604.53V359.64C664.92 331.33 677.44 316.09 700.3 316.09C723.16 316.09 735.68 331.33 735.68 359.64V604.53Z",
                    ease: "power1.inOut"
                }, .1)
                .to(logo.querySelector('.letter-d'), {
                    duration: .3,
                    morphSVG: "M945.62 149.619H857.55V516.169H945.62C1007.67 516.169 1041.42 483.419 1041.42 420.829V245.969C1041.42 183.369 1007.67 149.629 945.62 149.629V149.619ZM983.72 416.009C983.72 448.119 971.2 462.819 943.44 462.819H915.25V202.959H943.44C971.2 202.959 983.72 217.649 983.72 249.769V416.009Z",
                    ease: "power1.inOut"
                }, .2)
                .to(logo.querySelector('.letter-e'), {
                    duration: .3,
                    morphSVG: "M857.88 982.86H1035.25V929.521H915.58V808.25H1015.11V754.901H915.58V627.82H1035.25V574.48H857.88V982.86Z",
                    ease: "power1.inOut"
                }, .3)
                .to(logo.querySelector('.letter-a'), {
                    duration: .3,
                    morphSVG: "M1177.78 260.301C1120.07 260.301 1084.69 296.771 1084.69 356.651V989.701L1142.39 989.151V751.401H1213.16V866.181L1270.86 866.731V356.661C1270.86 296.791 1235.47 260.311 1177.78 260.311V260.301ZM1142.39 698.061V357.201C1142.39 328.891 1154.91 313.651 1177.78 313.651C1200.65 313.651 1213.16 328.891 1213.16 357.201V698.061H1142.39Z",
                    ease: "power1.inOut"
                }, .3)
                .to(logo.querySelector('.letter-l'), {
                    duration: .3,
                    morphSVG: "M1387.1 813.12V258.1H1329.4V867.54H1483.43V813.12H1387.1Z",
                    ease: "power1.inOut"
                }, .4)

            tl.to(logo.querySelector('.letter-m'), {
                duration: .3,
                morphSVG: logo.querySelector('.letter-m')?.getAttribute("d") as SVGPathValue | MorphSVGVars | undefined,
                ease: "power1.inOut"
            }, .4)
                .to(logo.querySelector('.letter-o'), {
                    duration: .3,
                    morphSVG: logo.querySelector('.letter-o')?.getAttribute("d") as SVGPathValue | MorphSVGVars | undefined,
                    ease: "power1.inOut"
                }, .5)
                .to(logo.querySelector('.letter-d'), {
                    duration: .3,
                    morphSVG: logo.querySelector('.letter-d')?.getAttribute("d") as SVGPathValue | MorphSVGVars | undefined,
                    ease: "power1.inOut"
                }, .6)
                .to(logo.querySelector('.letter-e'), {
                    duration: .3,
                    morphSVG: logo.querySelector('.letter-e')?.getAttribute("d") as SVGPathValue | MorphSVGVars | undefined,
                    ease: "power1.inOut"
                }, .6)
                .to(logo.querySelector('.letter-a'), {
                    duration: .3,
                    morphSVG: logo.querySelector('.letter-a')?.getAttribute("d") as SVGPathValue | MorphSVGVars | undefined,
                    ease: "power1.inOut"
                }, .7)
                .to(logo.querySelector('.letter-l'), {
                    duration: .3,
                    morphSVG: logo.querySelector('.letter-l')?.getAttribute("d") as SVGPathValue | MorphSVGVars | undefined,
                    ease: "power1.inOut"
                }, .8)
        }

        const stopTimelineAfterCurrentCycle = () => {
            if (tl) {
                tl.repeat(0);
                tl.repeatDelay(0);
                tl.eventCallback("onComplete", () => {
                    tl?.kill();
                    tl = null;
                });
            }
        };

        if (logo.classList.contains('logo-animated--auto')) {
            createTimeline();
        }

        logo.addEventListener('mouseenter', () => {
            isHovered = true;
            createTimeline();
        });

        logo.addEventListener('mouseleave', () => {
            isHovered = false;

            if (!logo.classList.contains('logo-animated--auto')) {
                stopTimelineAfterCurrentCycle();
            }
        });
    });
}
